import { render, staticRenderFns } from "./RuleTable.vue?vue&type=template&id=3f69a452&scoped=true"
import script from "./RuleTable.vue?vue&type=script&lang=js"
export * from "./RuleTable.vue?vue&type=script&lang=js"
import style0 from "./RuleTable.vue?vue&type=style&index=0&id=3f69a452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f69a452",
  null
  
)

export default component.exports